<template>
  <v-container my-5>
    <p class="display-1 text-xs-center mb-3">This district account has expired. Please contact your math coordinator to renew.</p>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>

